<template lang="html">

<section class="widgets">
  <div class="row">
    <div class="col-md-6 grid-margin">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title mb-0">Statistics</h4>
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-inline-block pt-3">
              <div class="d-flex">
                <h2 class="mb-0">$10,200</h2>
                <div class="d-flex align-items-center ml-2">
                  <i class="mdi mdi-clock text-muted"></i>
                  <small class=" ml-1 mb-0">Updated: 9:10am</small>
                </div>
              </div>
              <small class="text-gray">Raised from 89 orders.</small>
            </div>
            <div class="d-inline-block">
              <div class="bg-success px-4 py-2 rounded">
                <i class="mdi mdi-buffer text-white icon-lg"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 grid-margin">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title mb-0">Daily Order</h4>
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-inline-block pt-3">
              <div class="d-flex">
                <h2 class="mb-0">$2256</h2>
                <div class="d-flex align-items-center ml-2">
                  <i class="mdi mdi-clock text-muted"></i>
                  <small class=" ml-1 mb-0">Updated: 05:42pm</small>
                </div>
              </div>
              <small class="text-gray">hey, let’s have lunch together</small>
            </div>
            <div class="d-inline-block">
              <div class="bg-warning px-4 py-2 rounded">
                <i class="mdi mdi-wallet text-white icon-lg"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-4 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <div class="d-flex flex-row">
            <img src="../../src/assets/images/faces/face11.jpg" class="img-lg rounded"/>
            <div class="ml-3">
              <h6>Maria</h6>
              <p class="text-muted">maria@gmail.com</p>
              <p class="mt-2 text-success font-weight-bold">Designer</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <div class="d-flex flex-row">
            <img src="../../src/assets/images/faces/face9.jpg" class="img-lg rounded"/>
            <div class="ml-3">
              <h6>Thomas Edison</h6>
              <p class="text-muted">thomas@gmail.com</p>
              <p class="mt-2 text-success font-weight-bold">Developer</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <div class="d-flex flex-row">
            <img src="../../src/assets/images/faces/face12.jpg" class="img-lg rounded"/>
            <div class="ml-3">
              <h6>Edward</h6>
              <p class="text-muted">edward@gmail.com</p>
              <p class="mt-2 text-success font-weight-bold">Tester</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-4 grid-margin">
      <div class="card">
        <div class="card-body">
          <div class="d-flex flex-row align-items-top">
            <i class="mdi mdi-facebook text-facebook icon-md"></i>
            <div class="ml-3">
              <h6 class="text-facebook">2.62 Subscribers</h6>
              <p class="mt-2 text-muted card-text">You main list growing</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4 grid-margin">
      <div class="card">
        <div class="card-body">
          <div class="d-flex flex-row align-items-top">
            <i class="mdi mdi-linkedin text-linkedin icon-md"></i>
            <div class="ml-3">
              <h6 class="text-linkedin">5k connections</h6>
              <p class="mt-2 text-muted card-text">You main list growing</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4 grid-margin">
      <div class="card">
        <div class="card-body">
          <div class="d-flex flex-row align-items-top">
            <i class="mdi mdi-twitter text-twitter icon-md"></i>
            <div class="ml-3">
              <h6 class="text-twitter">3k followers</h6>
              <p class="mt-2 text-muted card-text">You main list growing</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-4 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <div class="d-flex justify-content-between">
            <h4 class="card-title">Activity</h4>
            <i class="mdi mdi-dots-vertical"></i>
          </div>
          <p class="card-description">What's people doing right now</p>
          <div class="list d-flex align-items-center border-bottom py-3">
            <img class="img-sm rounded-circle" src="../../src/assets/images/faces/face4.jpg" alt="">
            <div class="wrapper w-100 ml-3">
              <p class="mb-0"><b>Dobrick </b>posted in Material</p>
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                  <i class="mdi mdi-clock text-muted mr-1"></i>
                  <p class="mb-0">That's awesome!</p>
                </div>
                <small class="text-muted ml-auto">2 hours ago</small>
              </div>
            </div>
          </div>
          <div class="list d-flex align-items-center border-bottom py-3">
            <img class="img-sm rounded-circle" src="../../src/assets/images/faces/face5.jpg" alt="">
            <div class="wrapper w-100 ml-3">
              <p class="mb-0"><b>Stella </b>posted in Material</p>
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                  <i class="mdi mdi-clock text-muted mr-1"></i>
                  <p class="mb-0">That's awesome!</p>
                </div>
                <small class="text-muted ml-auto">3 hours ago</small>
              </div>
            </div>
          </div>
          <div class="list d-flex align-items-center border-bottom py-3">
            <img class="img-sm rounded-circle" src="../../src/assets/images/faces/face7.jpg" alt="">
            <div class="wrapper w-100 ml-3">
              <p class="mb-0"><b>Peter </b>posted in Material</p>
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                  <i class="mdi mdi-clock text-muted mr-1"></i>
                  <p class="mb-0">That's Great!</p>
                </div>
                <small class="text-muted ml-auto">1 hours ago</small>
              </div>
            </div>
          </div>
          <div class="list d-flex align-items-center pt-3">
            <img class="img-sm rounded-circle" src="../../src/assets/images/faces/face6.jpg" alt="">
            <div class="wrapper w-100 ml-3">
              <p class="mb-0"><b>Nateila </b>posted in Material</p>
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                  <i class="mdi mdi-clock text-muted mr-1"></i>
                  <p class="mb-0">That's awesome!</p>
                </div>
                <small class="text-muted ml-auto">1 hours ago</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">Recomended</h4>
          <div class="wrapper d-flex align-items-center py-2 border-bottom">
            <img class="img-sm rounded-circle" src="../../src/assets/images/faces/face5.jpg" alt="profile">
            <div class="wrapper ml-3">
              <h6 class="ml-1 mb-1">Stella Davidson</h6>
              <small class="text-muted mb-0"><i class="mdi mdi-map-marker-outline mr-1"></i>New York City, USA</small>
            </div>
            <div class="badge badge-pill badge-info ml-auto px-1 py-1"><i class="mdi mdi-check font-weight-bold"></i></div>
          </div>
          <div class="wrapper d-flex align-items-center py-2 border-bottom">
            <img class="img-sm rounded-circle" src="../../src/assets/images/faces/face6.jpg" alt="profile">
            <div class="wrapper ml-3">
              <h6 class="ml-1 mb-1">Daniel Russel</h6>
              <small class="text-muted mb-0"><i class="mdi mdi-map-marker-outline mr-1"></i>Florida, USA</small>
            </div>
            <div class="badge badge-pill badge-success ml-auto px-1 py-1"><i class="mdi mdi-plus font-weight-bold"></i></div>
          </div>
          <div class="wrapper d-flex align-items-center py-2 border-bottom">
            <img class="img-sm rounded-circle" src="../../src/assets/images/faces/face7.jpg" alt="profile">
            <div class="wrapper ml-3">
              <h6 class="ml-1 mb-1">Bruno King</h6>
              <small class="text-muted mb-0"><i class="mdi mdi-map-marker-outline mr-1"></i>Arkansas, USA</small>
            </div>
            <div class="badge badge-pill badge-info ml-auto px-1 py-1"><i class="mdi mdi-check font-weight-bold"></i></div>
          </div>
          <div class="wrapper d-flex align-items-center py-2 border-bottom">
            <img class="img-sm rounded-circle" src="../../src/assets/images/faces/face8.jpg" alt="profile">
            <div class="wrapper ml-3">
              <h6 class="ml-1 mb-1">David Moore</h6>
              <small class="text-muted mb-0"><i class="mdi mdi-map-marker-outline mr-1"></i>Arizon, USA</small>
            </div>
            <div class="badge badge-pill badge-success ml-auto px-1 py-1"><i class="mdi mdi-plus font-weight-bold"></i></div>
          </div>
          <div class="wrapper d-flex align-items-center py-2 mb-4">
            <img class="img-sm rounded-circle" src="../../src/assets/images/faces/face9.jpg" alt="profile">
            <div class="wrapper ml-3">
              <h6 class="ml-1 mb-1">Rafell John</h6>
              <small class="text-muted mb-0"><i class="mdi mdi-map-marker-outline mr-1"></i>Alaska, USA</small>
            </div>
            <div class="badge badge-pill badge-success ml-auto px-1 py-1"><i class="mdi mdi-plus font-weight-bold"></i></div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">Messages</h4>
          <div class="preview-list">
            <div class="preview-item border-bottom px-0">
              <div class="preview-thumbnail">
                <img src="../../src/assets/images/faces/face6.jpg" alt="image" class="rounded-circle"/>
              </div>
              <div class="preview-item-content d-flex flex-grow">
                <div class="flex-grow">
                  <h6 class="preview-subject">Richard Joy
                    <span class="float-right small">
                      <span class="text-muted pr-3">13.06.2017</span>
                    </span>
                  </h6>
                  <p>Thanks for the support!</p>
                </div>
              </div>
            </div>
            <div class="preview-item border-bottom px-0">
              <div class="preview-thumbnail">
                <img src="../../src/assets/images/faces/face8.jpg" alt="image" class="rounded-circle"/>
              </div>
              <div class="preview-item-content d-flex flex-grow">
                <div class="flex-grow">
                  <h6 class="preview-subject">William Alex
                    <span class="float-right small">
                      <span class="text-muted pr-3">08.07.2017</span>
                    </span>
                  </h6>
                  <p>Meeting is postponed</p>
                </div>
              </div>
            </div>
            <div class="preview-item border-bottom px-0">
              <div class="preview-thumbnail">
                <img src="../../src/assets/images/faces/face9.jpg" alt="image" class="rounded-circle"/>
              </div>
              <div class="preview-item-content d-flex flex-grow">
                <div class="flex-grow">
                  <h6 class="preview-subject">David Grey
                    <span class="float-right small">
                      <span class="text-muted pr-3">15.07.2017</span>
                    </span>
                  </h6>
                  <p>Please approve the request</p>
                </div>
              </div>
            </div>
            <div class="preview-item border-bottom px-0">
              <div class="preview-thumbnail">
                <img src="../../src/assets/images/faces/face11.jpg" alt="image" class="rounded-circle"/>
              </div>
              <div class="preview-item-content d-flex flex-grow">
                <div class="flex-grow">
                  <h6 class="preview-subject">Aleena Abraham
                    <span class="float-right small">
                      <span class="text-muted pr-3">12.06.2017</span>
                    </span>
                  </h6>
                  <p>Hope to see you tomorrow</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

</template>

<script lang="js">
export default {
  name: 'widgets'
}
</script>

<style scoped lang="scss">
.widgets {

}
</style>



// WEBPACK FOOTER //
// src/views/widgets.vue